import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "supplierInput",
    "supplierId",
    "unitPrice",
    "leadtime",
    "requestedDeliveryDate",
    "orderCode",
    "basisType",
    "basisId",
    "priceReferenceDate",
    "priceFromQuantity",
    "packageQuantity",
    "updateSource",
    "sourceFields",
    "sourcePreview"
  ]

  connect() {
    if (this.hasUpdateSourceTarget && this.hasSourceFieldsTarget) {
      this.toggleSourceFields()
    }
  }

  selectSuggestion(event) {
    const suggestion = event.currentTarget.dataset
    const radioButton = event.currentTarget.querySelector("input[type='radio']")
    if (radioButton) radioButton.checked = true

    this.supplierInputTarget.value = suggestion.supplierLabel || ""
    this.supplierIdTarget.value = suggestion.supplierId || ""
    this.unitPriceTarget.value = suggestion.unitPrice || ""
    this.leadtimeTarget.value = suggestion.leadtime || ""
    this.orderCodeTarget.value = suggestion.orderCode || ""
    this.basisTypeTarget.value = suggestion.basisType || ""
    this.basisIdTarget.value = suggestion.basisId || ""
    this.priceReferenceDateTarget.value = suggestion.referenceDate || ""
    this.priceFromQuantityTarget.value = suggestion.quantity || ""
    this.packageQuantityTarget.value = suggestion.packageQuantity || "1"

    if (suggestion.leadtime) this.setRequestedDeliveryDate(Number(suggestion.leadtime))

    if (this.hasSourcePreviewTarget) {
      this.sourcePreviewTarget.textContent =
        suggestion.basisType === "parts_supplier"
          ? "Die ausgewählte Bezugsquelle wird mit den finalen Bestelldaten aktualisiert."
          : "Eine exakt passende Bezugsquelle wird aktualisiert, andernfalls neu angelegt."
    }
  }

  manualSupplierChanged() {
    this.basisTypeTarget.value = ""
    this.basisIdTarget.value = ""
    if (this.hasSourcePreviewTarget) {
      this.sourcePreviewTarget.textContent =
        "Eine exakt passende Bezugsquelle wird aktualisiert, andernfalls neu angelegt."
    }
  }

  toggleSourceFields() {
    if (!this.hasUpdateSourceTarget || !this.hasSourceFieldsTarget) return

    const sourceUpdateEnabled = this.updateSourceTarget.checked
    this.sourceFieldsTarget.classList.toggle("d-none", !sourceUpdateEnabled)
    this.sourceFieldsTarget.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = !sourceUpdateEnabled
    })
  }

  syncDeliveryDateFromLeadtime() {
    const value = this.leadtimeTarget.value
    if (value === "") {
      this.requestedDeliveryDateTarget.value = ""
      return
    }

    this.setRequestedDeliveryDate(Number(value))
  }

  syncLeadtimeFromDeliveryDate() {
    const value = this.requestedDeliveryDateTarget.value
    if (!value) {
      this.leadtimeTarget.value = ""
      return
    }

    const [year, month, day] = value.split("-").map(Number)
    if (![year, month, day].every(Number.isFinite)) return

    const today = new Date()
    const todayUtc = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())
    const deliveryDateUtc = Date.UTC(year, month - 1, day)
    this.leadtimeTarget.value = Math.round((deliveryDateUtc - todayUtc) / 86400000)
  }

  setRequestedDeliveryDate(leadtime) {
    if (!Number.isFinite(leadtime)) return

    const date = new Date()
    date.setHours(12, 0, 0, 0)
    date.setDate(date.getDate() + leadtime)
    this.requestedDeliveryDateTarget.value = [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, "0"),
      String(date.getDate()).padStart(2, "0")
    ].join("-")
  }
}
